/* 무료보험 프로모션 추가부분 */
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'
import { fetchHouse, fetchIsAppliedById, fetchIsPromotionCanceled } from '@Root/slices/myhouse/promotion'

export default function usePromotion() {
  const dispatch = useDispatch()
  const promotion = useSelector((state: RootState) => state.promotion)

  const loadIsAppliedMember = useCallback(() => {
    dispatch(fetchIsAppliedById())
  }, [dispatch])

  const loadHouse = useCallback(
    (houseNo: number) => {
      dispatch(fetchHouse(houseNo))
    },
    [dispatch],
  )

  const loadIsPromotionCanceled = useCallback(
    (houseNo: number) => {
      dispatch(fetchIsPromotionCanceled(houseNo))
    },
    [dispatch],
  )

  return {
    promotion,
    loadIsAppliedMember,
    loadHouse,
    loadIsPromotionCanceled,
  }
}
